export default {
    namespaced: true,
    state: {
        editingProfile: null,
    },

    mutations: {

        setEditingProfile(state, payload) {
            state.editingProfile = payload;
        },

        clearEditingProfile(state) {
            state.editingProfile = null;
        },
    }

};
